import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import { EmployeeDashboardMobileStyles } from '../../../styles/mobileStyles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import PartialIcon from '../../components/PartialIcon';
import { formatAs, DateFnsFormats, getAsStartAndEndTimeFormat } from '../../../../common-client2/src/services/ukgDateTime';


class ShiftCard extends Component {

    static colors = {
        myRequest: {
            r: 138,
            g: 33,
            b: 230,
            a: 0.41
        },
        shift: {
            r: 0,
            g: 74,
            b: 152,
            a: 0.41
        },
        paycode: {
            r: 72,
            g: 217,
            b: 96,
            a: 0.41
        },
        toCover: {
            r: 255,
            g: 221,
            b: 0,
            a: 0.10
        },
        shiftSwap: {
            r: 255,
            g: 122,
            b: 89,
            a: 0.41
        },
        openShift: {
            r: 238,
            g: 15,
            b: 15,
            a: 0.41
        },
        voluntaryTimeOff: {
            r: 94,
            g: 178,
            b: 94,
            a: 0.41
        }
    }

    calculateShiftDuration(startDate, endDate) {
        return moment.duration(moment.utc(endDate).diff(moment.utc(startDate))).asHours().toFixed(2);
    }

    render() {
        const { classes, color, shiftType, startDate, endDate, orgJob, handleOnClick = () => { }, displayDate = false, icon = null, status = '', isPartial = false, shiftTemplateLabel } = this.props;
        let rgb, rgba;
        if (color) {
            rgb = `rgb(${color.r}, ${color.g}, ${color.b})`;
            rgba = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
        }

        return (
            <div className={classes.shiftCard} style={color ? { "borderLeftColor": rgb } : null} onClick={handleOnClick} >
                {
                    shiftType ?
                        <React.Fragment>
                            <div className={classes.shiftCardTypeWrapper}>
                                <div className={classes.shiftCardType} style={color ? { "color": rgb, "backgroundColor": rgba } : null} >
                                    {shiftType}
                                </div>
                            </div>

                            <div className={classes.statusLabel}>
                                {icon}
                                <span>
                                    {status}
                                </span>
                            </div>
                        </React.Fragment>
                        : null
                }
                {
                    displayDate ?
                        <Typography style={{ fontWeight: 700 }}>
                            {formatAs(startDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
                        </Typography>
                        : null
                }
                <div style={{ display: 'flex' }}>
                    <Typography variant={'subtitle1'}>
                        {`${shiftTemplateLabel ?? ""} ${getAsStartAndEndTimeFormat(startDate, endDate)} [${this.calculateShiftDuration(startDate, endDate)}]`}
                    </Typography>
                    {isPartial && (
                        <div style={{ display: 'flex', alignItems: 'center' }}><PartialIcon /></div>
                    )}
                </div>
                <Typography variant={'subtitle2'}>
                    {`${formatAs(startDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}`}
                </Typography>
                <Typography variant={'subtitle2'} style={{ fontWeight: 300, color: '#C1C1C1' }}>
                    {orgJob}
                </Typography>
            </div>
        );
    }
}

export default withStyles(EmployeeDashboardMobileStyles)(ShiftCard);
